import React from 'react';
import GlowSystemSchema from './GlowSystemSchema';

const SolutionSection: React.FC = () => {
  const blocks = [
    {
      title: 'La Clarté',
      description: 'Un positionnement si tranché que tes clients idéaux se reconnaissent instantanément.',
    },
    {
      title: 'La Liberté',
      description: 'Un tunnel de vente, des emails et des automatisations qui travaillent 24h/24 — même le dimanche. Relances clients, classement des leads, confirmations : tout tourne en arrière-plan, sans toi.',
    },
    {
      title: 'La Sérénité',
      description: 'Une stratégie de contenu sur 3 mois déjà prête. Fini la page blanche.',
    },
    {
      title: 'La Structure',
      description: 'Des automatisations sur mesure (Airtable, Make, Brevo) qui transforment l\'administratif en machine silencieuse et efficace.',
    },
  ];

  return (
    <section id="methode" className="section-lg">
      <div className="container mx-auto px-4" style={{ maxWidth: 1060 }}>

        {/* ── Intro text — full width, centered ──────── */}
        <div className="reveal text-center max-w-2xl mx-auto mb-4">
          <div className="flex justify-center mb-6">
            <span className="reveal-child badge-pill">
              <span className="badge-pill-dot" />
              Les résultats
            </span>
          </div>

          <h2
            className="reveal-child font-display text-foreground mb-6 leading-[1.08]"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}
          >
            En 6 semaines, ton business{' '}
            <span
              className="font-medium"
              style={{ fontStyle: 'italic', color: 'hsl(var(--rose-text))' }}
            >
              change de dimension.
            </span>
          </h2>

          <p className="reveal-child text-lg text-muted-foreground leading-relaxed mb-5">
            Chez Glow Lab, on ne te donne pas un PDF de conseils théoriques à ranger dans un dossier.
            On{' '}
            <strong className="text-foreground">construit</strong>. Pour de vrai.
          </p>

          <p className="reveal-child text-sm text-muted-foreground italic leading-relaxed">
            On prend tes idées, ton talent et ton message, et on les injecte dans une machine de vente automatisée. C'est la fin du « post and pray ».
          </p>
        </div>

        {/* ── Schéma animé — full width ──────────────── */}
        <GlowSystemSchema />

        {/* ── Transition text ────────────────────────── */}
        <p className="reveal text-center text-sm text-muted-foreground italic leading-relaxed max-w-xl mx-auto mb-12">
          Mon rôle est de créer ce pont solide entre ton contenu et ton compte en banque.
        </p>

        {/* ── Result blocks card ─────────────────────── */}
        <div className="reveal max-w-xl mx-auto">
          <div
            className="rounded-2xl p-8 lg:p-10 relative overflow-hidden transition-all duration-300 hover:-translate-y-1"
            style={{
              background: 'hsl(var(--off-white))',
              border: '1px solid hsl(var(--border))',
              borderTop: '2px solid hsl(var(--rose) / 0.5)',
              boxShadow: '0 4px 24px rgba(226, 176, 212, 0.1)',
            }}
          >
            {/* Subtle rose gradient wash at top */}
            <div
              className="absolute top-0 left-0 right-0 h-24 pointer-events-none"
              style={{
                background: 'linear-gradient(to bottom, hsl(var(--rose) / 0.04), transparent)',
              }}
            />

            <p className="relative reveal-child text-xs font-body font-semibold uppercase tracking-widest text-muted-foreground mb-7">
              En 6 semaines, tu repars avec
            </p>

            <div className="relative space-y-6">
              {blocks.map((block, i) => (
                <div
                  key={i}
                  className="reveal-child px-3"
                >
                  <p
                    className="font-display font-semibold text-foreground mb-1.5"
                    style={{ fontSize: 'clamp(1rem, 2vw, 1.15rem)', color: 'hsl(var(--rose-text))' }}
                  >
                    {block.title}
                  </p>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {block.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SolutionSection;
